/**
 * A country's name in the reader's language when it is stored as an ISO 3166 code ("FR" → "France"),
 * or as it is when it is already a name.
 */
export function countryName(country: string, locale: string): string {
  if (!/^[A-Za-z]{2}$/.test(country)) return country;
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(country.toUpperCase()) ?? country;
  } catch {
    return country;
  }
}
